import React, { useEffect, useState } from 'react';
import { getProjectId, hasJdMartVertical } from '../../lib/common';
import { useLocalStorage, useSessionStorage } from '../../hooks';
import { CreateTicket, GetDispoDetials } from '../../api';
import useAlert from '../../hooks/useAlert';
import OthersIsuue from './OthersIsuue';
import TicketCreateRespPage from './TicketCreateRespPage';
import AttachmentsPage from './AttachmentsPage';

const DummyTicketPage = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const selectedIssueVal = decodeURIComponent(queryParams.get('issueType'));
  const [setAlert] = useAlert();
  const projectId = getProjectId();
  const [selectedBusiness] = useLocalStorage('selectedBusiness', '');
  const [userDetails] = useSessionStorage('userDetails', '');
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const [dummyTicketCreateResp, setDummyTicketCreateResp] = useState({});
  const [loading, setLoading] = useState(false);
  const [issueSubIssueData, setIssueSubIssueData] = useState({
    subIssueData: [],
    allIssuesArr: [],
    subIssuesObj: {},
  });
  const [selectedSubIssue, setSelectedSubIssue] = useState('');
  const [finalIssuesObj, setFinalIssuesObj] = useState({
    issue: '',
    subIssue: '',
  });
  const [showOthersAttchments, setShowOthersAttchments] = useState(false);

  useEffect(() => {
    const handleDummyTicketCreate = async () => {
      try {
        setLoading(true);
        const params = {
          vertical: hasJdMartVertical()
            ? 'JD MART CORPORATE'
            : selectedIssueVal === 'ECS' || (selectedIssueVal === 'Others' && finalIssuesObj?.issue === 'ECS')
              ? 'RETENTION'
              : 'LISTING',
          category: 'CS',
          ticket_creator: 'BUSINESS',
          nm:
            projectId === 'csportal'
              ? selectedBusiness?.compname || ''
              : selectedBusinessGenio?.contractPersonName || selectedBusinessGenio?.companyName || '',
          created_by: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
          mob: projectId === 'csportal' ? userDetails?.mobile || '' : selectedBusinessGenio?.mobile || '',
          issue_type: selectedIssueVal === 'Others' ? finalIssuesObj?.issue : selectedIssueVal,
          issue_sub_type: selectedIssueVal === 'Others' ? finalIssuesObj?.subIssue : 'dummy',
          issue_comment: '',
          document: [],
          city: projectId === 'genio' ? selectedBusinessGenio?.city || '' : selectedBusiness?.data_city,
          oid: '',
          orderid: '',
          docid: projectId === 'genio' ? selectedBusinessGenio?.docId || '' : selectedBusiness?.docid || '',
          src: projectId === 'genio' ? 'sales-genio' : 'business',
          src_typ:
            projectId === 'genio' ? (selectedBusinessGenio?.concern === 'client' ? 'client' : 'internal') : 'csportal',
          src_nm: projectId === 'csportal' ? userDetails?.fullName || '' : profile?.full_name || '',
          src_mob: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
          projectId: projectId === 'csportal' ? 1 : '',
          parentId: projectId === 'genio' ? selectedBusinessGenio?.parentId || '' : selectedBusiness?.parentid || '',
          compnm: projectId === 'genio' ? selectedBusinessGenio?.companyName || '' : selectedBusiness?.compname || '',
          source: `dummy_subissue_${projectId}`,
        };

        const res = await CreateTicket(params);
        if (res?.errorCode === 0) {
          const result = {
            ticketId: res?.result?.ticket_id || '',
            agentName: res?.result?.empdetails?.empnm || res?.result?.empdetails?.empname || '',
            empId: res?.result?.empdetails?.empid || '',
          };
          setDummyTicketCreateResp(result || {});
          sessionStorage.setItem('ticketResp', JSON.stringify(result));
        } else {
          setAlert({
            message: res?.message || '',
            status: false,
          });
        }
        setLoading(false);
      } catch (err) {
        console.log('Error in ticket creation', err);
      }
      setLoading(false);
    };
    const storageTicketResp = JSON.parse(sessionStorage.getItem('ticketResp'));
    if (
      ((selectedIssueVal !== 'Others' && selectedIssueVal) ||
        (selectedIssueVal === 'Others' && finalIssuesObj?.subIssue)) &&
      !storageTicketResp?.ticketId
    ) {
      handleDummyTicketCreate();
    }
  }, [finalIssuesObj?.subIssue]);

  const getSubIssueData = (dispoData) => {
    const mapIssueType = selectedIssueVal === 'Others' ? 'OTHER ISSUES' : selectedIssueVal;
    if (dispoData && dispoData.length > 0) {
      const subIssueRes = dispoData.filter((each) => {
        if (each.issue_type === mapIssueType) {
          return each;
        }
        return null;
      });

      const subIssueDataRes =
        subIssueRes &&
        subIssueRes[0] &&
        Object.keys(subIssueRes[0]).length > 0 &&
        subIssueRes[0]?.disp_obj &&
        Object.keys(subIssueRes[0]?.disp_obj).length > 0
          ? subIssueRes[0]?.disp_obj
          : {};
      return subIssueDataRes;
    }
    return [];
  };

  useEffect(() => {
    const handleGetIssueSubIssues = async () => {
      const dispoParams = {
        category: 'cs',
        vertical: hasJdMartVertical() ? 'JD MART CORPORATE' : 'listing',
        ticketCreator: 'business',
      };

      try {
        const res = await GetDispoDetials(dispoParams, 1, projectId);
        const dispoData = res || [];
        const subIssueData = getSubIssueData(dispoData);
        const updtSubIssueData = Object.keys(subIssueData).map((eachKey) => eachKey.trim());
        const upd = Object.fromEntries(Object.entries(subIssueData).map(([key, val]) => [key.trim(), val]));

        setIssueSubIssueData({
          subIssueData: [...updtSubIssueData] || [],
          allIssuesArr: dispoData || {},
          subIssuesObj: upd || {},
        });
      } catch (err) {
        console.log('Error: ', err);
      }
    };
    handleGetIssueSubIssues();
  }, []);

  const subIssuesArr = issueSubIssueData?.subIssueData?.length > 0 ? issueSubIssueData?.subIssueData || [] : [];
  return (
    <div>
      {(selectedIssueVal !== 'Others' && selectedSubIssue) ||
      (selectedIssueVal === 'Others' && showOthersAttchments) ? (
        <AttachmentsPage
          ticketCreateResp={dummyTicketCreateResp}
          setAlert={setAlert}
          selectedSubIssue={selectedSubIssue}
          subIssuesObj={selectedIssueVal === 'Others' ? {} : issueSubIssueData?.subIssuesObj || {}}
          selectedIssueVal={selectedIssueVal}
          finalIssuesObj={finalIssuesObj}
        />
      ) : (
        <>
          {selectedIssueVal !== 'Others' ? (
            <TicketCreateRespPage
              ticketCreateResp={dummyTicketCreateResp}
              subIssuesArr={subIssuesArr}
              setSelectedSubIssue={setSelectedSubIssue}
              selectedIssueVal={selectedIssueVal}
              loading={loading}
              subIssuesObj={issueSubIssueData?.subIssuesObj || {}}
              setShowOthersAttchments={setShowOthersAttchments}
            />
          ) : (
            <>
              {selectedSubIssue ? (
                <TicketCreateRespPage
                  ticketCreateResp={dummyTicketCreateResp}
                  subIssuesArr={subIssuesArr}
                  setSelectedSubIssue={setSelectedSubIssue}
                  selectedIssueVal={selectedIssueVal}
                  loading={loading}
                  subIssuesObj={issueSubIssueData?.subIssuesObj || {}}
                  setShowOthersAttchments={setShowOthersAttchments}
                />
              ) : (
                <OthersIsuue
                  allIssuesArr={issueSubIssueData?.allIssuesArr || {}}
                  setSelectedSubIssue={setSelectedSubIssue}
                  setFinalIssuesObj={setFinalIssuesObj}
                  selectedBusiness={selectedBusiness}
                />
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default DummyTicketPage;
